import { userEmail, userId } from '@gonfalon/constants/constants';
import { postTracking } from '@gonfalon/openapi/operations/postTracking';

export type InternalApiTrackingOptions = {
  includeIdentity?: boolean;
  userAgent?: string;
};

type InternalApiTrackingProperties = Record<string, boolean | number | string>;

export const trackEventsViaInternalApi = async (
  event: string,
  properties: InternalApiTrackingProperties,
  options: InternalApiTrackingOptions = {},
) => {
  const enriched: InternalApiTrackingProperties = { ...properties };
  if (options.includeIdentity !== false) {
    const id = userId();
    if (id !== undefined && !('userId' in properties)) {
      enriched.userId = id;
    }
    const email = userEmail();
    if (email !== undefined && !('userEmail' in properties)) {
      enriched.userEmail = email;
    }
  }

  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (options.userAgent === undefined) {
    headers['LD-Bypass-UA-Tracking'] = '';
  } else {
    headers['User-Agent'] = options.userAgent;
  }
  const response = await postTracking(
    {
      body: {
        event,
        Properties: enriched,
      },
    },
    {
      headers,
    },
  );
  if (response.response.ok) {
    return;
  } else {
    throw new Error('failed to create analytics event');
  }
};
